export const paymentConstants = {
    ADOBE_ANALYTICS_FORM_NAME: 'Payment',
    PAYMENT_STEPS: [
        "Payment information",
        "Confirm payment details",
        "Payment submitted"
    ]
}